"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeRemovedValuableItemsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeRemovedValuableItemsWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeRemovedValuableItemsWidget, _super);
    function AnnualHomeRemovedValuableItemsWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnualHomeRemovedValuableItemsWidget.prototype.render = function () {
        var valuableItems = this.props.interaction.valuableItems || [];
        var filteredOutSpecifiedItems = valuableItems
            .filter(function (item) { return !item.flowValuable; })
            .filter(function (item) { return item.coverLocation === services_1.ValuableItemCoverLocation.ANYWHERE; });
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: filteredOutSpecifiedItems.length > 0 &&
                (0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-panel font-weight-extra-light quote row banner banner-info margin-x-0", children: (0, jsx_runtime_1.jsxs)("div", { className: "p-0 d-flex col removed-valuable-item align-items-start", children: [(0, jsx_runtime_1.jsx)("div", { className: "removed-item-info-icon selected flex-start" }), (0, jsx_runtime_1.jsx)("div", { children: this.renderWording(filteredOutSpecifiedItems) })] }) }) }));
    };
    AnnualHomeRemovedValuableItemsWidget.prototype.renderWording = function (filteredOutSpecifiedItems) {
        var aggregator = (0, commonFunctions_1.getAggregatorDisplayName)(this.props.interaction.source);
        var dynamicProductList = this.prepareDynamicProductListString(filteredOutSpecifiedItems);
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We have removed ", (0, jsx_runtime_1.jsx)("b", { children: dynamicProductList }), " you have listed on ", aggregator, " as they are worth less than \u00A32,000 each. We have increased the limit on your personal belongings cover (below) for these items. Please check the level of cover meets your needs."] }));
    };
    AnnualHomeRemovedValuableItemsWidget.prototype.prepareDynamicProductListString = function (items) {
        var itemDescriptions = items.map(function (item) { return item.description; });
        var itemCount = items.length;
        var descriptions;
        if (itemDescriptions.length === 1) {
            descriptions = itemDescriptions[0];
        }
        else {
            var lastItemDescription = itemDescriptions.pop();
            descriptions = "".concat(itemDescriptions.join(', '), " and ").concat(lastItemDescription);
        }
        return "".concat(itemCount, " specified item").concat(itemCount > 1 ? "s" : "", " (").concat(descriptions, ")");
    };
    return AnnualHomeRemovedValuableItemsWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomeRemovedValuableItemsWidget = AnnualHomeRemovedValuableItemsWidget;
//# sourceMappingURL=AnnualHomeRemovedValuableItemsWidget.js.map